export default {
  name: 'tag',
  uniqKey: '_id',
  crudMapping: {
    readMany: 'tags',
    readOne: 'tag',
    create: 'createTag',
    update: 'updateTag',
    // delete: 'deleteTag',
  },
  readManySchema: {
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Tag',
      type: 'object',
      required: [
        'title',
        'score',
      ],
      properties: {
        title: {
          type: 'string',
        },
        tagQuestionId: {
          type: 'string',
        },
        score: {
          type: 'number',
        },
        // system: {
        //   title: 'Curation Engine Tuning',
        //   type: 'object',
        //   properties: {
        //     kind: {
        //       title: 'Type',
        //       type: 'string',
        //       enum: Object.keys(TAG_TYPE_MAP),
        //       enumName: Object.values(TAG_TYPE_MAP),
        //     },
        //   },
        // },
      },
    },
    uiSchema: {
      tagQuestionId: {
        'ui:widget': 'hasOneWidget',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/tag.js